import React from "react";
import { getLabel } from "../labels";
import { systemCode } from "../..";

export default function ExternalDetailsLink(props) {
    if (systemCode !== 'BGAME') {
        return null;
    }

    function handleClick(e) {
        e.stopPropagation();
    }

    return (
        <a
            href={`https://www.bgame.it/checkbet/biglietto_web?id=${props.ticketId}`}
            target="_blank"
            rel="noreferrer"
            className="details-link"
            onClick={handleClick}
        >
            {`${getLabel('mybets.dettagli')} New`}
            &#x2197;
        </a>
    );
}
